import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'temp-file-list-card-settings',
  templateUrl: './file-list-card-settings.component.html',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
})
export class FileListCardSettingsComponent {
  includeChildDocuments = false;
}
